export enum InAppNotificationTypesEnum {
  AssigneeChange = 'AssigneeChange',
  MissingSellingPrices = 'MissingSellingPrices',
}
